import React from 'react';
// import './DisplayStyle.css';

function Display({ display }) {
    return (
        <p>
            {display}
        </p>
    )
}

export default Display;